import { Account } from "@rentablo/api/apiv1";

export const getUpdateBankConnectionUrl = (
  account:
    | Pick<Account, "id" | "type" | "bankConnectionId" | "bankConnectionType">
    | undefined
): string | undefined => {
  if (
    !account?.bankConnectionType ||
    account.bankConnectionType === "NETFONDS"
  ) {
    return undefined;
  }

  const isWealthApi = account.bankConnectionType === "WEALTH_API";
  const isDepot = account.type === "01_depot";
  const params = new URLSearchParams();
  if (account.id !== undefined) {
    if (isWealthApi && isDepot) params.set("depotId", String(account.id));
    params.set("returnTo", `/${isDepot ? "depots" : "accounts"}/${account.id}`);
  }
  const query = params.toString();

  return `${
    isWealthApi ? "/update-wealth-api-connection" : "/update-bank-connection"
  }/${account.bankConnectionId}${query ? `?${query}` : ""}`;
};
